import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGrid = () => {
  return (
    <g>
      <path d="m15.146.1533h-14.292a.7.7 0 0 0 -.7.7v14.293a.7.7 0 0 0 .7.7h14.292a.7.7 0 0 0 .7-.7v-14.2928a.7.7 0 0 0 -.7-.7002zm-13.5918 6.1651h3.3638v3.3632h-3.3638zm4.7642 0h3.3632v3.3632h-3.3632zm4.7637 0h3.3638v3.3632h-3.3639zm3.3638-1.4h-3.3639v-3.3647h3.3638zm-4.7642 0h-3.3633v-3.3647h3.3632zm-8.1275-3.3647h3.3638v3.3643h-3.3638zm0 9.5283h3.3638v3.3643h-3.3638zm4.7642 0h3.3632v3.3643h-3.3632zm8.1274 3.3643h-3.3638v-3.3643h3.3638z" />
    </g>
  );
};

export default withIcon(IconGrid);
